import React from "react";
import { Button, Grid2, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { BlogType } from "src/shared/config";
import { RoutePaths } from "src/app/model";

type BlogItemProps = {
  blog: BlogType;
};

export const BlogItem: React.FC<BlogItemProps> = (props) => {
  const { blog } = props;
  const navigate = useNavigate();

  const handleApply = () => {
    const path = `${RoutePaths.BLOG}/${blog.id}`;

    navigate(path);
  };

  return (
    <Grid2
      size={{ lg: 1, md: 1, sm: 2 }}
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      alignItems="flex-start"
      gap={1}
    >
      <img
        src={blog.imagePath}
        alt={blog.title}
        width="100%"
        style={{
          aspectRatio: 2 / 1.2,
          objectFit: "cover",
          borderRadius: "12px",
        }}
      />

      <Typography variant="h6" fontWeight="bold">
        {blog.title}
      </Typography>

      <Typography variant="subtitle2" color="primary.dark" fontWeight="400">
        {blog.date}
      </Typography>

      <Typography
        variant="subtitle1"
        fontWeight="400"
        sx={{
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {blog.description}
      </Typography>

      <Button
        variant="contained"
        size="small"
        color="primary"
        onClick={handleApply}
        sx={{
          alignSelf: "center",
        }}
      >
        Read more
      </Button>
    </Grid2>
  );
};
